import React, { useState, useEffect } from 'react';
import { Flex, Box, Card, Avatar, ScrollArea, Text, Button } from '@radix-ui/themes';

const TeacherSubscriptions = ({ subscriptions }) => {
  const [displayCount, setDisplayCount] = useState(8);
  const [visibleSubs, setVisibleSubs] = useState([]);
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (subscriptions) {
      setVisibleSubs(subscriptions.slice(0, displayCount));
      setRemaining(Math.max(0, subscriptions.length - displayCount));
    }
  }, [subscriptions, displayCount]);

  const handleShowMore = () => {
    setDisplayCount(prev => prev + 8);
  };

  if (!subscriptions || subscriptions.length === 0) {
    return (
      <Box p="4">
        <Text size="2" color="gray" align="center">
          No students have subscribed yet
        </Text>
      </Box>
    );
  }

  return (
    <div>
      <ScrollArea type="auto" scrollbars="vertical" style={{ maxHeight: '500px' }}>
        <Flex direction="column" gap="2">
          {visibleSubs.map((subscription) => (
            <Flex align="center" gap="2" key={subscription.id}>
              <Avatar
                size="2"
                src={subscription.student.user.profile_picture}
                alt={`${subscription.student.user.firstname} ${subscription.student.user.lastname}`}
                fallback={subscription.student.user.firstname[0]}
              />
              <div className="student-details">
                <Text size='2'>{`${subscription.student.user.firstname} ${subscription.student.user.lastname}`}</Text>
                {/* <Text size='1' color='gray'>{subscription.status}</Text> */}
              </div>
            </Flex>
          ))}

          {remaining > 0 && (
            <Box pt="2">
              <Button
                variant="ghost"
                onClick={handleShowMore}
                size="1"
                className="w-full"
              >
                Show {Math.min(remaining, 8)} more students
              </Button>
            </Box>
          )}
        </Flex>
      </ScrollArea>
    </div>
  );
};

export default TeacherSubscriptions;
